<template>
  <b-tabs>
    <b-tab v-for="(tab, index) in tabs" :key="index" :active="tab.active">
      <template #title>
        <feather-icon :icon="tab.icon" />
        <span>{{ tab.title }}</span>
      </template>

      <component :is="tab.component" />
    </b-tab>
  </b-tabs>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import TabContent from './TabContent.vue'
import Integration from '@/views/App/Integracoes/Index.vue'
import Leads from '@/views/App/Chat/Leads.vue'
import Chat from '@/views/App/Chat/Chats.vue'
import DeashbordChat from '@/views/App/Dashboard/DashbordChat.vue'
import AtivacaoLeads from '@/views/App/Chat/AtivaçãoLeads.vue'
export default {
  components: {
    BTabs,
    BTab,
    TabContent,
    Integration,
    Chat,
    Leads,
    DeashbordChat,
    AtivacaoLeads,
  },
  data() {
    return {
      tabs: [
        {
          title: 'Ativação',
          icon: 'CodeIcon',
          component: 'AtivacaoLeads',
          active: true,
        },
        {
          title: 'Deashboard',
          icon: 'GridIcon',
          component: 'DeashbordChat',
          active: true,
        },
        {
          title: 'Leads',
          icon: 'UsersIcon',
          component: 'Leads',
          active: false,
        },
        {
          title: 'Gerenciar Fluxos',
          icon: 'MessageSquareIcon',
          component: 'Chat',
          active: false,
        },

        {
          title: 'Integrações',
          icon: 'Share2Icon',
          component: 'Integration',
          active: false,
        },
      ],
    }
  },
}
</script>

<style>
ul[role="tablist"] {
  display: flex;
  justify-content: center;
  background: var(--dk-bg-card, white);
  padding: 10px 0;
}
</style>
